import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/contexts/auth-context';
import { retryPageView, routeChanged, setSignedOut, watchConsent } from '@/lib/metaPixel';

/**
 * The Meta Pixel's PageView on each route change (and the first render), its link to the cookie banner, and the auth state the sign-up page needs
 * (it counts only once auth has resolved to "no user": a signed-in user is redirected away, the same rule as GuestOnly). Renders nothing. Mounted by
 * App.tsx only in a web build with VITE_META_PIXEL_ID; every rule lives in src/lib/metaPixel.ts.
 */
export default function MetaPixelTracker() {
  const [pathname] = useLocation();
  const { user, loading } = useAuth();
  const signedOut = !loading && !user;
  useEffect(() => watchConsent(), []);
  useEffect(() => {
    setSignedOut(signedOut);
    if (signedOut) retryPageView();
  }, [signedOut]);
  useEffect(() => {
    routeChanged(pathname);
  }, [pathname]);
  return null;
}
